import { BaseComponent } from '../../lib/BaseComponent.js';

/**
 * Loading Spinner Component
 * Displays an animated loading indicator
 */
export class LoadingSpinner extends BaseComponent {
  private size: 'small' | 'medium' | 'large' = 'medium';
  private message: string = '';

  constructor() {
    super();
  }

  /**
   * Set the spinner size
   */
  public setSize(size: 'small' | 'medium' | 'large'): void {
    this.size = size;
    this.shadow.innerHTML = '';
    this.render();
  }

  /**
   * Set the loading message
   */
  public setMessage(message: string): void {
    this.message = message;
    this.shadow.innerHTML = '';
    this.render();
  }

  protected async render(): Promise<void> {
    this.addStyles(this.getStyles());

    const container = this.createElement('div', { className: 'spinner-container' });

    const spinner = this.createElement('div', { className: `spinner spinner-${this.size}` });
    container.appendChild(spinner);

    if (this.message) {
      const messageEl = this.createElement('div', { className: 'spinner-message' }, this.message);
      container.appendChild(messageEl);
    }

    this.shadow.appendChild(container);
  }

  private getStyles(): string {
    return `
      .spinner-container {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 12px;
      }

      .spinner {
        border-radius: 50%;
        border: 3px solid #f3f4f6;
        border-top-color: #3b82f6;
        animation: spin 0.8s linear infinite;
      }

      @keyframes spin {
        to {
          transform: rotate(360deg);
        }
      }

      .spinner-small {
        width: 20px;
        height: 20px;
        border-width: 2px;
      }

      .spinner-medium {
        width: 40px;
        height: 40px;
        border-width: 3px;
      }

      .spinner-large {
        width: 60px;
        height: 60px;
        border-width: 4px;
      }

      .spinner-message {
        font-size: 14px;
        color: #6b7280;
        text-align: center;
      }
    `;
  }
}

// Register custom element
customElements.define('loading-spinner', LoadingSpinner);
